import { AuthStorage } from "@ponder-core/auth/auth.storage";
import { SvgIcon, SvgIconMap } from "@ponder-shared/utils/svgIcons";

/**
 * Navigates to an user-specific page.
 */
export class SidebarButtonRouteComponent {
    public readonly completeRoute!: string;
    public readonly svgIcon!: string;

    public constructor(
        public readonly label: string, 
        icon: SvgIcon, route: string,
        public readonly disabled: boolean) {
        this.completeRoute = this.getCompleteRoute(route);
        this.svgIcon = SvgIconMap.get(icon)!;
    }

    private getCompleteRoute(route: string): string {
        var username = AuthStorage.getUsername();

        if (!username) {
            return "/";
        } else {
            return `/user/${username}/${route}`;
        }
    }
}